(function(angular) {
	angular.module('mobilezuz')
		.config(['$stateProvider', 'PAGE_ACCESS', function($stateProvider, PAGE_ACCESS) {
			$stateProvider.state('app.terms-and-conditions', {
				url: '/terms-and-conditions',
				data: {
					stateAccess: PAGE_ACCESS.ALLOW,
					bodyClass: 'info-text',
					metaTags: {
						title: 'Terms & conditions'
					}
				},
				views: {
					'@': {
						templateUrl: 'views/bind-html.html',
						controller: 'TermsCtrl'
					}
				}
			});
		}]).controller('TermsCtrl', ['$rootScope', '$scope', 'Retailer',
		function($rootScope, $scope, Retailer) {
			$rootScope.title = 'Terms & conditions';
			Retailer.getRetailerSettings().then(function(response) {
				$scope.content = response.settings.agreementText;
			});
		}]);
})(angular);